'use strict';

import $ from 'jquery';
import 'jquery-validation';

class FormManager {
    constructor(config = {}) {

        $.validator && $.validator.addClassRules("g-recaptcha-response", {
            required: true
        });

        $.validator && $.validator.addMethod("pwcheck", function (value, element) {
            return this.optional(element) || /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,16}$/i.test(value);
        }, "Your password must be 8-16 characters long and include uppercase letters, lowercase letters and at least one number.");

        this.config = {
            ignore: [],
            rules: {},
            messages: {},
            errorElement: 'span',
            errorClass: 'error',
            errorPlacement: function (error, element) {
                error.appendTo( element.parents('.field') );
            },
            highlight: function (element) {
                $(element).addClass('invalid');
            },
            unhighlight: function (element) {
                $(element).removeClass('invalid');
            },
            submitHandler: function (form) {
                const $form = $(form);
                const formSettings = this.settings;
                const formData = new FormData(form);

                $form.find('.formResponse').remove();

                if (formSettings.beforeSubmit && formSettings.beforeSubmit.call(this, form, formData, formSettings) === false) {
                    return false;
                }

                $form.addClass('loading');

                const ajaxConfig = $.extend(true, {}, {
                    method: $form.attr('method') || 'POST',
                    data: formData,
                    processData: false, // Important! Tell $ not to process the data
                    contentType: false, // Important! Tell $ not to set contentType
                    onSuccess: function (response) {
                        if (formSettings.onSuccess && formSettings.onSuccess.call(this, response, formSettings) === false) {
                            return false;
                        }

                        if ( formSettings.resetOnSuccess ) {
                            form.reset();
                        }

                        if ( response.success ) {
                            popupManager.setContent(response.data.content);
                        } else {
                            $('<div class="formResponse"></div>').html(response.data.content).appendTo($form.find('.formBody'));
                        }

                        return false;
                    },
                    onError: function (response) {
                        //$('<div class="formResponse"></div>').html(response.data.content).appendTo($form.find('.formBody'));
                        return false;
                    },
                    onComplete: function () {
                        $form.removeClass('loading');
                    }
                }, formSettings.ajaxSettings );
                ajaxManager.request(ajaxConfig);
            },
            onInit: null,
            beforeSubmit: null,
            onSuccess: null,
            resetOnSuccess: true,
            ajaxSettings: {},
            ...config
        };
    }

    initForm(selector, options) {
        const settings = $.extend(true, {}, this.config, options);

        $(document).on('afterShow.fb', function( e, instance, slide ) {
            if (settings.onInit && settings.onInit.call(this, selector, settings) === false) {
                return false;
            }
            slide.$slide.find(selector).validate(settings);
        });

        return $(selector).each(function (index, form) {
            if (settings.onInit && settings.onInit.call(this, selector, settings) === false) {
                return false;
            }

            $(form).validate(settings);
        });
    }
}

window.formManager = new FormManager();